<template>
  <el-drawer
      :visible.sync="show"
      :append-to-body="true"
      :close-on-press-escape="true"
      direction="ltr"
      :show-close="true"
      :size="drawerSize + '%'"
      :modal="false"
      class="sidebar-drawer md:hidden block"
  >
    <div class="sidebar-drawer-wrapper p-4 flex flex-col h-full">
      <div class="sidebar-drawer-body flex-auto">
        <NavList/>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import NavList from "@/components/layout/NavList.vue";
import {mapActions} from "vuex";

export default {
  name: "SidebarDrawer",
  components: {NavList},
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get: function () {
        return this.$props.collapsed
      },
      set: function(newVal) {
        this.$emit("toggle")
      }
    }
  },
  data() {
    return {
      drawerSize: 40
    }
  },
  methods: {
    ...mapActions(["initMenus"]),
    setDrawerSize() {
      this.drawerSize = window.innerWidth > 475
          ? window.innerWidth < 640
              ? 70
              : window.innerWidth > 1280
                  ? this.$emit("toggle")
                  : 45
          : 100;
    }
  },
  mounted() {
    this.initMenus()
    this.setDrawerSize()
  },
  watch: {
    '$route.path'() {
      this.$emit("toggle", false)
    }
  }
}
</script>